module.exports = __webpack_public_path__ + "static/media/main-bg-3.f8b1d5d1.jpg";